<template>
	<section class="ProjectAppointmentsPage">
		<header class="Header">
			<a class="back-button" href="/kwaliteit-afspraken">
				<ArrowLeftIcon/>
			</a>
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span
				v-if="isLoading"
				style="color: #777777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #ffffff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;"
			>
				<LoadingIndicator style="height: 16px;"/>
			</span>
		</header>
		<main v-if="company != null">
			<div
				class="project"
			>
				<div class="phone-section">
					<a
						class="icon"
						:class="{disabled: company.phone == null}"
						:href="company.phone == null ? '' : `tel:${company.phone}`"
						@click.stop=""
					>
						<Phone-icon/>
					</a>
					<span>
						{{ company.salutation }} {{
							company.companyname
						}}
					</span>
				</div>
				<div class="location-section">
					<a
						class="icon"
						:class="{disabled: company.locationUrl == null}"
						:href="company.locationUrl == null ? '' : company.locationUrl"
						target="_blank"
						@click.stop=""
					>
						<Navigation-icon/>
					</a>
					<span>
						{{ company.visitingaddress_street }} {{
							company.visitingaddress_streetnumber
						}}
						<br/>
						{{ company.visitingaddress_zipcode }}
						<br/>
						{{ company.visitingaddress_city }}
					</span>
				</div>
				<div class="time-section">
					<span>
						{{
							company.customfield_kwaliteitbegintijd != null
								? company.customfield_kwaliteitbegintijd : "-"
						}}
					</span>
				</div>
			</div>
			<ProjectAppointmentDetailSection
				title="Afspraakdetails"
				class="section"
				:open="sections['APPOINTMENT_DETAILS'].open"
				:show-next-button="true"
				@toggle-open="toggleSection('APPOINTMENT_DETAILS')"
				@open-next="toggleSection('PROJECT_LINES')"
			>
				<div class="specifications">
					<p class="specification-line">
						<span>Kwaliteitscontrole</span>
						<span>{{
								empty(company.customfield_datumkwaliteitscontrole) ? "-"
									: reverseDate(company.customfield_datumkwaliteitscontrole)
							}}
						</span>
					</p>
					<p class="specification-line">
						<span>Medewerker</span>
						<span> {{
								company.customfield_kwaliteitmedewerker != null
									? company.customfield_kwaliteitmedewerker : "-"
							}}
						</span>
					</p>
					<div class="divider"></div>

					<p class="specification-line">
						<span>Adviesgesprek</span>
						<span>{{
								empty(company.customfield_datumaantafel) ? "-"
									: company.customfield_datumaantafel
							}}
						</span>
					</p>
					<p class="specification-line">
						<span>Medewerker</span>
						<span> {{
								company.agent != null && company.agent.display_name != null
									? company.agent.display_name : "-"
							}}
						</span>
					</p>
					<div class="divider"></div>
					<p class="specification-line">
						<span>Notitie</span>
						<textarea class="note-area" :value="empty(company.customfield_kwaliteitnotitie) ? 'Geen notities' : company.customfield_kwaliteitnotitie" disabled readonly></textarea>
					</p>
				</div>
			</ProjectAppointmentDetailSection>
			<ProjectAppointmentDetailSection
				title="Uitwerking adviesgesprek"
				class="section"
				:open="sections['IMPLEMENTATION'].open"
				:show-next-button="true"
				@toggle-open="toggleSection('IMPLEMENTATION')"
				@open-next="toggleSection('PHOTOS')"
			>
				<div class="card-grid">
					<a
						:href="'/files/getById?file_id=' + file.id"
						target="_blank"
						class="file-card"
						v-for="file of uitwerkingFiles"
					>
						<img
							:src="'/files/getById?height=600&width=600&file_id=' + file.id"
							:alt="file.file_name"
						>
					</a>
				</div>
			</ProjectAppointmentDetailSection>
			<ProjectAppointmentDetailSection
				title="Foto's adviesgesprek"
				class="section"
				:open="sections['PHOTOS'].open"
				:show-next-button="true"
				@toggle-open="toggleSection('PHOTOS')"
				@open-next="toggleNextSectionByOrder(sections['PHOTOS'].order)"
			>
				<div class="card-grid">
					<a :href="'/files/getById?file_id=' + file.id" target="_blank" class="file-card"
					   v-for="file of photoFiles">
						<img :src="'/files/getById?height=600&width=600&file_id=' + file.id"
							 :alt="file.file_name">
					</a>
				</div>
			</ProjectAppointmentDetailSection>
			<QualitySpouwSection
				v-if="company.projects.length > 0 && company.projects[0].appointments.length > 0"
				title="Spouwmuurisolatie"
				class="section"
				:open="sections['EXECUTION_DETAILS'].open"
				:show-next-button="true"
	            :appointment="company.projects[0].appointments[0]"
				:company-id="company.id"
				:variables="{appointmentId: company.projects[0].appointments[0].id, projectId: company.projects[0].id}"
				@toggle-open="toggleSection('EXECUTION_DETAILS')"
				@open-next="toggleNextSectionByOrder(sections['EXECUTION_DETAILS'].order)"
			></QualitySpouwSection>
			<QualityQuestionSection
				v-for="(questionGroup, index) in questionGroups"
				:title="questionGroup.name"
				:company-id="company.id"
				:open="sections[questionGroup.name].open"
				:disabled="allowedToEdit() === false"
				@toggle-open="toggleSection(questionGroup.name)"
				:question-group="questionGroup"
				:show-next-button="sections[questionGroup.name].order !== lastOrder"
				:show-final-save-button="sections[questionGroup.name].order === lastOrder"
				:appointment-id="company.projects[0].appointments[0].id"
				:project-id="company.projects[0].id"
				class="section"
				@open-next="toggleNextSectionByOrder(sections[questionGroup.name].order)"
			></QualityQuestionSection>
		</main>
	</section>
</template>

<script>
import Button from "@/components/Button";
import CreateNote from "@/components/CreateNote.vue";
import LoadingIndicator from "@/components/LoadingIndicator";
import ProjectAppointmentCancellationPopup from "@/components/ProjectAppointmentCancellationPopup.vue";
import ProjectAppointmentDetailSection from "@/components/ProjectAppointmentDetailSection";
import ProjectAppointmentExtraPopup from "@/components/ProjectAppointmentExtraPopup.vue";
import UitvoeringQuestionSection from "@/components/ProjectAppointmentQuestionSection";
import QualityQuestionSection from "@/components/qualityAppointment/QualityQuestionSection.vue";
import QualitySpouwSection from "@/components/qualityAppointment/QualitySpouwSection.vue";
import {client} from "@/store";
import moment from "moment";
import "moment/locale/nl";
import {
	ArrowLeftIcon,
	ArrowRightIcon,
	CalendarIcon,
	ClockIcon,
	LogOutIcon,
	NavigationIcon,
	PhoneIcon,
	RefreshCwIcon,
	SearchIcon
} from "vue-feather-icons";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
	components: {
		QualityQuestionSection,
		QualitySpouwSection,
		Button,
		LoadingIndicator,
		PhoneIcon,
		NavigationIcon,
		RefreshCwIcon,
		LogOutIcon,
		ArrowLeftIcon,
		ArrowRightIcon,
		CalendarIcon,
		SearchIcon,
		ClockIcon,
		ProjectAppointmentDetailSection,
		UitvoeringQuestionSection
	},

	data() {
		return {
			id: this.$route.params.id,
			company: null,
			uitwerkingFiles: [],
			photoFiles: [],
			supportPhotoFiles: [],
			teamMembers: [],
			questionGroups: [],
			extraQuestionGroups: [],
			questionnaire: null,
			defaultGroupsOrder: 4,
			lastOrder: 4,
			lastAllowedOrder: 5,
			sections: {
				"APPOINTMENT_DETAILS": {
					open: true,
					order: 1
				},
				"PROJECT_LINES": {
					open: false,
					order: 2
				},
				"IMPLEMENTATION": {
					open: false,
					order: 3
				},
				"PHOTOS": {
					open: false,
					order: 4
				},
				"EXECUTION_DETAILS": {
					open: false,
					order: 4
				}
			}
		};
	},

	watch: {
		"$route.params.id": function (id) {
			this.getCompany(id);
		}
	},

	mounted() {
		this.getCompany(this.id);
	},

	computed: {
		...mapState({
			isLoading: "loading"
		}),
		formattedDate: () => date => {
			return moment(date, "YYYY-MM-D").format("dd, D MMM YYYY");
		}
	},

	methods: {
		...mapActions({
			logoutUser: "auth/logoutUser",
			setQualityShowKlanttevredenheid: "mobile/setQualityShowKlanttevredenheid"
		}), ...mapGetters({
			allowedTo: "auth/allowedTo"
		}),

		getNextSectionNameByOrder(currentOrder) {
			for (const [key, section] of Object.entries(this.sections)) {
				// it could be possible that the next order is bigger than the current order + 1
				// sections are ordered by order, so we can just check if the order is bigger than the current order
				if (section.order >= currentOrder + 1) {
					return key;
				}
			}
			return null;
		},

		toggleNextSectionByOrder(currentOrder) {
			let nextSection = this.getNextSectionNameByOrder(currentOrder);
			if (nextSection != null) {
				this.toggleSection(nextSection);
			}
		},

		cancelAppointment() {
			this.$modal.show(ProjectAppointmentCancellationPopup, {
				appointment: this.appointment
			}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},
		openAppointmentExtra() {
			this.$modal.show(ProjectAppointmentExtraPopup, {
				questionGroup: this.extraQuestionGroups[0],
				projectId: this.appointment.project.id,
				companyId: this.appointment.company.id,
				appointmentId: this.appointment.id,
				disabled: this.allowedToEdit() === false

			}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},

		toggleSection(section) {
			const open = this.sections[section].open;
			// close all sections if the current section was closed
			if (open === false) {
				for (const [key, section] of Object.entries(this.sections)) {
					if (section.open === true) {
						this.sections[key].open = false;
					}
				}
			}
			this.sections[section].open = !this.sections[section].open;
			this.$forceUpdate();
		},

		reverseDate(date) {
			return date.split("-").reverse().join("-");
		},

		isSupportAppointment() {
			if(this.appointment == null) {
				return false;
			}

			if(this.appointment.project == null) {
				return false;
			}

			return (this.appointment.project.gripp_projectphase_id === 11
				&& this.appointment.supportTickets != null
				&& this.appointment.supportTickets.length > 0);
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},

		addSectionsForQuestionsGroups(groups) {
			this.lastAllowedOrder = this.defaultGroupsOrder + groups[0].order;
			const order = this.defaultGroupsOrder;
			for (let i = 0; i < groups.length; i++) {
				const questionGroup = groups[i];
				if (!this.sections.hasOwnProperty(questionGroup.name)) {
					this.sections[questionGroup.name] = {
						open: false,
						order: order + questionGroup.order
					};
					this.lastOrder = order + questionGroup.order;
				}
				const requiredQuestion = questionGroup.questions.find(question =>{
					const config = JSON.parse(question.config);
					return config.validators != null && config.validators.includes('required')});
				if (requiredQuestion == null) {
					if(order + questionGroup.order === this.lastAllowedOrder){
						if(groups.length - 1 === i) {
							this.lastAllowedOrder = -1;
							continue;
						}
						this.lastAllowedOrder = order + groups[i + 1].order;
					}
					continue;
				}
				if (requiredQuestion.hasOwnProperty('answers') === false || requiredQuestion.answers == null || requiredQuestion.answers.length === 0) {
					continue;
				}
				const answer = requiredQuestion.answers[0];
				if (!this.empty(answer.value) || !this.empty(answer.text_value) || !this.empty(answer.file_id)) {
					if (groups.length - 1 === i) {
						this.lastAllowedOrder = -1
						continue;
					}
					this.lastAllowedOrder = order + groups[i + 1].order;
				}
			}
		},

		getCompany(id) {
			client.query(`
			query ($id: Int!) {
				company(id: $id) {
						id,
						salutation,
						companyname,
						phone,
						email,
						firstname,
						lastname,
						infix,
						visitingaddress_street,
						visitingaddress_streetnumber,
						visitingaddress_zipcode,
						visitingaddress_city,
						visitingaddress_lng,
					  	visitingaddress_lat,
					  	customfield_afspraakdatum,
					  	customfield_datumkwaliteitscontrole,
						customfield_kwaliteitbegintijd,
						customfield_kwaliteiteindtijd,
						customfield_kwaliteitmedewerkerid,
						customfield_kwaliteitmedewerker,
						customfield_kwaliteitnotitie,
						customfield_datumaantafel,
						agent {
							id,
							display_name
						},
						projects {
							id,
							quality_questionnaire {
								id,
								name,
								question_groups {
									id,
									name,
									order,
									constant,
									questions {
										id,
										rev,
										name,
										order,
										constant,
										type,
										config,
										parent_id,
										answers {
											id,
											value,
											text_value,
											file_id,
											question_id,
											question_rev
										}
									}
								}
							},
							appointments {
								id,
								date,
								teamLeader {
									id,
									display_name
								},
								historicTeamMembers {
			                        username,
			                        display_name
			                    },
			                    questionnaire {
				                    id,
									name,
									question_groups {
										id,
										name,
										order,
										constant,
										questions {
											id,
											rev,
											name,
											order,
											type,
											config,
											parent_id,
											answers {
												id,
												value,
												text_value,
												file_id,
												question_id,
												question_rev
											}
										}
									}
							}
						}
					}

				}
			}`, {id: parseInt(this.id, 10)})
				.then((data) => {
					const userAgent = navigator.userAgent || navigator.vendor || window.opera;
					let device = "other";
					if (/android/i.test(userAgent)) {
						device = "Android";
					}

					let tempCompany = data.company;
					tempCompany.locationUrl = null;

					if (tempCompany.phone == null || tempCompany.phone.trim() === "") {
						tempCompany.phone = tempCompany.mobile;
					}
					if (tempCompany.visitingaddress_lat != null && tempCompany.visitingaddress_lat.trim() !== "" && tempCompany.visitingaddress_lng != null && tempCompany.visitingaddress_lng.trim() !== "") {
						// open geo intent on android, otherwise open google maps
						if (device === "Android") {
							tempCompany.locationUrl = `geo:?q=${tempCompany.visitingaddress_street}+${tempCompany.visitingaddress_streetnumber},${tempCompany.visitingaddress_zipcode}+${tempCompany.visitingaddress_city}`;
						} else {
							tempCompany.locationUrl = ` https://maps.google.com/maps?q=${tempCompany.visitingaddress_street}+${tempCompany.visitingaddress_streetnumber},${tempCompany.visitingaddress_zipcode}+${tempCompany.visitingaddress_city}`;
						}

					}
					switch (tempCompany.gripp_salutation_id) {
						case "1":
							tempCompany.salutation = "Dhr.";
							break;
						case "2":
							tempCompany.salutation = "Mevr.";
							break;
						default:
							tempCompany.salutation = "Dhr / Mevr.";
							break;
					}

					this.company = tempCompany;
					this.questionnaire = this.company.projects[0].quality_questionnaire;
					this.addSectionsForQuestionsGroups(this.questionnaire.question_groups);
					this.questionGroups = this.questionnaire.question_groups;
					this.getFiles(tempCompany.id);
				}).catch(error => {
					this.$router.back();
				});
		},

		setupSupportAppointment() {
			if(this.appointment.resolveSupportTickets.length === 0) {
				return;
			}
			this.defaultGroupsOrder = 3;
			this.lastOrder = 3;
			this.lastAllowedOrder = 4;
			this.sections = {
				"APPOINTMENT_DETAILS": {
					open: true,
					order: 1
				},
				"PROJECT_LINES": {
					open: false,
					order: 2
				},
				"SUPPORT_PHOTOS": {
					open: false,
					order: 3
				}
			}
		},

		setupNormalAppointment() {
			this.defaultGroupsOrder = 4;
			this.lastOrder = 4;
			this.lastAllowedOrder = 5;
			this.sections = {
				"APPOINTMENT_DETAILS": {
					open: true,
					order: 1
				},
				"PROJECT_LINES": {
					open: false,
					order: 2
				},
				"IMPLEMENTATION": {
					open: false,
					order: 3
				},
				"PHOTOS": {
					open: false,
					order: 4
				}}
		},

		getFiles(companyId) {
			client.query(`query($types: [String]!, $company_id: ID!) {
				getFiles(types: $types, company_id: $company_id) {
					id
					company_id
					file_name
					type
					upload_date
					size
				}
			}`, {
				company_id: companyId,
				types: [
					"sales/voorkant", "sales/achterkant", "sales/fotos"
				]
			}).then(result => {
				this.uitwerkingFiles = result.getFiles.filter(file => file.type !== "sales/fotos");
				this.photoFiles = result.getFiles.filter(file => file.type === "sales/fotos");
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Fout bij het ophalen van bestanden",
					type: "error",
					text: `bestanden konden niet opgehaald worden.`
				});
			});
		},

		allowedToEdit() {
			return true;
		}
	}
};
</script>

<style scoped lang="scss">
main {
	overflow: auto;
	height: calc(100% - 46px);
}

.ProjectAppointmentsPage {
	height: 100%;
}

.Header {
	justify-content: center;
}

.section {
	border-bottom: 2px solid #eeeeee;

	&:nth-last-child(1) {
		margin-bottom: 64px;
	}
}

.divider {
	margin: 16px 0;
	height: 2px;
	background-color: #eeeeee;
}

.start-project-container {
	padding: 16px 8px;
	border-bottom: 2px solid #eeeeee;

	.start-project-button {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 5px 16px;
		background-color: #35a5a4;
		color: white;
		border: none;
		border-radius: 4px;
		font-weight: bold;
		height: 36px;
		width: 100%;

		&:disabled {
			cursor: default;
		}

		svg {
			width: 16px;
			height: 16px;
			margin-right: 8px;
		}
	}
}

h2, h3 {
	margin: 0 0 0.5em 0;
}

.project {
	display: grid;
	background-color: #ffffff;
	border-bottom: 2px solid #eeeeee;
	grid-template-areas:
        "phone time"
        "location time";
	padding: 4px 0;
	color: #000000;
}

.project:nth-last-child(1) {
	margin-bottom: 150px;
}

.phone-section {
	grid-area: phone;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.location-section {
	grid-area: location;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.time-section {
	grid-area: time;
	display: flex;
	align-self: center;
	justify-content: flex-end;
	margin-right: 16px;
	align-items: center;
}

.time-section span {
	font-size: 2rem;
	font-weight: 900;
}

.icon {
	min-width: 60px;
	width: 60px;
	min-height: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	color: #ffffff;
	border-radius: 8px;
	margin-right: 16px;
}

.icon.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	text-decoration: none;
	pointer-events: none;
}

.phone-section .icon {
	background: #1f88e5;
}

.location-section .icon {
	background: #35a5a4;
}

.icon path {
	fill: #ffffff;
}

.icon polygon {
	fill: #ffffff;
}

.header-buttons {
	background: #eeeeee;
	border: none;
	box-shadow: none;
	color: #000000;
	font-size: 1rem;
	font-weight: 800;
	text-align: center;
}

.Header-logo {
	display: flex;
	height: 100%;
	width: 50%;
	align-items: center;
	justify-content: center;
}

.specification-line {
	display: flex;
	justify-content: space-between;
	margin: 16px 0;
	font-size: 18px;
	font-weight: 500;
}

.file-line {
	border: 2px solid #eeeeee;
	padding: 4px;
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	text-decoration: none;

	img {
		height: 64px;
		width: 64px;
		object-fit: cover;
		margin-right: 8px;
		border-radius: 4px;
	}
}

.card-grid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.file-card {
	display: flex;
	border: 2px solid #eeeeee;
	box-sizing: border-box;
	padding: 4px;
	margin: 4px;
	flex-direction: column;
	align-items: center;
	flex: 0 0 calc(50% - 8px);
	width: calc(50% - 8px);
	justify-content: space-between;

	img {
		aspect-ratio: 16/9;
		width: 100%;
	}

	span {
		justify-self: flex-end;
		align-self: start;
	}
}

.back-button {
	position: absolute;
	left: 8px;
}

.support-message {
	padding: 36px;
	color: #E53935;
	background-color: #f6dade;
	border-bottom: 2px solid #eeeeee;

	h2 {
		text-align: center;
		text-transform: uppercase;
	}

	p {
		font-size: 1.1rem;
		text-align: center;
	}
}

.note-area {
	width: 50%;
	min-height: 80px;
	box-sizing: border-box;
	border-radius: 5px;
	padding: 8px;
	background-color: #FFFFFF;
}
</style>
